var jade = require("C:\\Work\\David\\repo\\cartonomy-website\\Cartonomy-Website\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout-align=\"center center\" layout=\"row\" class=\"order-join-link\"><div layout=\"column\" flex=\"80\" layout-align=\"center center\" class=\"div\"><div class=\"title\">{{'client.join_link' | translate}}</div><div class=\"join-link\">{{invitationLink}}{{invitationCode}}</div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/views/orderSummaryPage.jade
// module id = 812
// module chunks = 0